module.exports = __webpack_public_path__ + "static/media/whatsApp.e8642b33.svg";